export enum ImgID
{
  None,

  // MenuScreen
  IconCoin,
  IconHeart,
  IconPlus,
  UI_MenuBg,
  UI_MenuCloud,
  UI_PlayButton,
  UI_PlayButtonHeader,
  UI_MenuBlockBg,
  UI_MenuSettingsIcon,
  UI_MenuAnimal1,
  UI_MenuAnimal2,
  UI_MenuAnimal3,
  UI_MenuAnimal4,
  UI_MenuAnimal5,
  UI_MenuAnimal6,
  UI_MenuAnimal7,
  UI_MenuAnimal8,

  // GameScreen
  IconSettings,
  IconSettingsPurple,
  IconSettingsRed,
  UI_GameBlockBg,
  UI_GameBlockBgPurple,
  UI_GameBlockBgRed,
  UI_GameLevelTape,
  UI_GameLevelTapePurple,
  UI_GameLevelTapeRed,
  UI_GameDifficultyPlatePurple,
  UI_GameDifficultyPlateRed,
  UI_GameSoundOn,
  UI_GameSoundOff,
  UI_GameMusicOn,
  UI_GameMusicOff,
  UI_GameVibrationOn,
  UI_GameVibrationOff,
  UI_GameExit,
  UI_ConveyorSide,
  UI_GameBoosterLockedTape,
  UI_GameBoosterBottom,
  UI_GameBoosterProgressBase,
  UI_GameBoosterProgressFill,
  UI_GameFreezeProgressBase,
  UI_GameFreezeProgressFill,

  // AdventureScreen
  UI_CoinBg,

  // DailyChallengeScreen

  // TryAgainChallengeDialog

  // DailyChallengeInfoOverlay

  // ChainOfferScreen
  UI_ChainOfferLockIcon,
  UI_ChainOfferVideoIcon,

  // AdventureInfoOverlay
  IconOverlayClose,

  // TutorialScreen
  IconTutorialCursor,
  UI_TutorialSubstrate,

  // NavigationBlock
  IconNavigationMenu,
  IconNavigationFriends,
  IconNavigationLeaderboard,
  IconNavigationLock,
  UI_NavigationMainBg,
  UI_NavigationBg,

  // ShopScreen
  UI_ShopBlockImg,
  UI_ShopBtn,

  // SettingsScreen
  UI_SettingsLinkBtn,

  // SettingsDialog
  UI_SettingsDialogCloseBtn,
  UI_SettingsDialogCopyBtn,
  UI_SettingsIconBg,

  // DeleteAccountDialog
  IconWarningYellow,
  UI_ConfirmSubstrate,

  // LoadingScreen
  UI_LoadingBg,
  UI_LoadingProgressBarBase,
  UI_LoadingProgressBarFill,
  UI_LoadingLogo,
  UI_GameLoadingAnimal1,
  UI_GameLoadingAnimal2,
  UI_GameLoadingAnimal3,
  UI_GameLoadingAnimal4,
  UI_GameLoadingAnimal5,
  UI_GameLoadingAnimal6,
  UI_GameLoadingShadow,
  UI_ConveyorLoadingLogo,
  UI_ConveyorLoadingPicture,
  UI_ConveyorResultBanner,
  UI_ConveyorWidget,
  UI_HappyFallLogo,
  UI_FirstStepsLogo,
  UI_FirstStepsCastleBg,
  UI_FirstStepsPanelHalf,
  UI_FirstStepsProgressTrack,
  UI_FirstStepsProgressFill,
  UI_FirstStepsKey,
  UI_FirstStepsChestClosed,
  UI_FirstStepsChestOpen,
  UI_FirstStepsTaskBg,
  UI_FirstStepsTaskBgDone,
  UI_FirstStepsTaskBarTrack,
  UI_FirstStepsTaskBarFill,
  UI_FirstStepsCheck,
  UI_FirstStepsButton,
  UI_HappyFallBg,
  UI_HappyFallRaccoon,
  UI_HappyFallRaccoonNoPrizes,
  UI_HappyFallBoard,
  UI_HappyFallHole,
  UI_ConveyorHudBg,
  UI_ConveyorHudHand,

  // Result goal
  UI_ResultProgressBarBg,
  UI_ResultProgressBarFill,
  UI_ResultProgressBarFillAvailable,
  UI_ResultStarBoxGoal,

  UI_GoalIceCube,
  UI_GoalCherryJar,
  UI_GoalIronCan,
  UI_GoalMetalCan,
  UI_GoalStoneBox,
  UI_GoalBrickBox,
  UI_GoalWatermelonBlock,
  UI_GoalWoodLog,
  UI_GoalPlasticBoxRed,

  // Common
  UI_CapsuleBlueRed,
  UI_CapsuleBluePurple,
  UI_CapsuleBlue,
  UI_PaternedBg,
  UI_GreenFrameBtn,
  UI_BlueBtn,
  UI_RedBtn,
  UI_OrangeBtn,
  UI_GrayBtn,
  UI_PurpleFrameBtn,
  UI_NonActiveBtn,
  UI_Fireworks,
  UI_FireworksThree,
  UI_TopBanner,
  UI_TopBannerHeader,
  UI_CrushedHeart,
  UI_ClockFrame,
  UI_ClockHand,
  UI_VideoIcon,
  UI_PlayDialogTop,
  UI_GameStartBoosterBg,
  UI_GameStartFireworkBooster,
  UI_GameStartMultiballsBooster,
  UI_GameStartBigBallBooster,
  UI_GameStartInfiniteBallsBooster,
  UI_GameFreezeBooster,
  UI_GameStartContentBg,
  UI_GameStartBoosterTitle,
  UI_GameStartRedCircle,
  UI_PlusBtn,
  UI_TooltipArrow,
  UI_RocketBooster,
  UI_LevelBoxShadow,

  // ConnectionFailedDialog
  UI_ConnectionFailedIcon,

  // BoosterDialog
  UI_BoosterNameBg,
  UI_BoosterPaternedBg,

  // ProfileDialog
  AvatarCircle,
  IconEdit,
  IconCopy,
  ProfileStarIcon,

  //AccountDialogs
  AppleIcon,
  GoogleIcon,
  PlusIconWhite,

  // Leaderboard
  FacebookIcon,
  IconAvatarSelected,
  UI_LeaderboardItemBg,
  UI_LeaderboardItemBgTop,
  UI_LeaderboardItemBgYou,
  UI_LeaderboardInfoButton,
  UI_LeaderboardInfoTopPart,
  UI_LeaderboardInfoCenterPart,
  UI_LeaderboardInfoBottomPart,
  UI_LeaderboardSpinner,
  UI_LeaderboardTabSide,
  UI_LeaderboardTabSideActive,
  UI_LeaderboardTabMiddle,
  UI_LeaderboardTabMiddleActive,

  // Daily tasks tutorial overlay
  UI_DailyTasksArrow,
  UI_DailyTasksCloseBtn,
  // UI_DailyTasksTowerShortcut,
  // UI_DailyTasksShortcut,

  // Daily tasks screen
  UI_DailyTasksTaskCoins,
  UI_DailyTasksTaskCannon,

  // GameResultOverlay
  UI_ResultBannerRibbon,
  UI_ResultBannerCannons,
  UI_ResultBottomHeader,

  // InviteFriendDialog
  UI_InviteFriendPic,

  // Avatars
  Avatar_0,
  Avatar_1,
  Avatar_2,
  Avatar_3,
  Avatar_4,
  Avatar_5,
  Avatar_6,
  Avatar_7,
  Avatar_8,

  // Country flags
  Flag_unknown,
  Flag_AD,
  Flag_AE,
  Flag_AF,
  Flag_AG,
  Flag_AI,
  Flag_AL,
  Flag_AM,
  Flag_AN,
  Flag_AO,
  Flag_AQ,
  Flag_AR,
  Flag_AS,
  Flag_AT,
  Flag_AU,
  Flag_AW,
  Flag_AX,
  Flag_AZ,
  Flag_BA,
  Flag_BB,
  Flag_BD,
  Flag_BE,
  Flag_BF,
  Flag_BG,
  Flag_BH,
  Flag_BI,
  Flag_BJ,
  Flag_BL,
  Flag_BM,
  Flag_BN,
  Flag_BO,
  Flag_BR,
  Flag_BS,
  Flag_BT,
  Flag_BW,
  Flag_BY,
  Flag_BZ,
  Flag_CA,
  Flag_CC,
  Flag_CD,
  Flag_CF,
  Flag_CG,
  Flag_CH,
  Flag_CI,
  Flag_CK,
  Flag_CL,
  Flag_CM,
  Flag_CN,
  Flag_CO,
  Flag_CR,
  Flag_CU,
  Flag_CV,
  Flag_CW,
  Flag_CX,
  Flag_CY,
  Flag_CZ,
  Flag_DE,
  Flag_DJ,
  Flag_DK,
  Flag_DM,
  Flag_DO,
  Flag_DZ,
  Flag_EC,
  Flag_EE,
  Flag_EG,
  Flag_EH,
  Flag_ER,
  Flag_ES,
  Flag_ET,
  Flag_EU,
  Flag_FI,
  Flag_FJ,
  Flag_FK,
  Flag_FM,
  Flag_FO,
  Flag_FR,
  Flag_GA,
  Flag_GB,
  Flag_GD,
  Flag_GE,
  Flag_GG,
  Flag_GH,
  Flag_GI,
  Flag_GL,
  Flag_GM,
  Flag_GN,
  Flag_GQ,
  Flag_GR,
  Flag_GS,
  Flag_GT,
  Flag_GU,
  Flag_GW,
  Flag_GY,
  Flag_HK,
  Flag_HN,
  Flag_HR,
  Flag_HT,
  Flag_HU,
  Flag_IC,
  Flag_ID,
  Flag_IE,
  Flag_IL,
  Flag_IM,
  Flag_IN,
  Flag_IQ,
  Flag_IR,
  Flag_IS,
  Flag_IT,
  Flag_JE,
  Flag_JM,
  Flag_JO,
  Flag_JP,
  Flag_KE,
  Flag_KG,
  Flag_KH,
  Flag_KI,
  Flag_KM,
  Flag_KN,
  Flag_KP,
  Flag_KR,
  Flag_KW,
  Flag_KY,
  Flag_KZ,
  Flag_LA,
  Flag_LB,
  Flag_LC,
  Flag_LI,
  Flag_LK,
  Flag_LR,
  Flag_LS,
  Flag_LT,
  Flag_LU,
  Flag_LV,
  Flag_LY,
  Flag_MA,
  Flag_MC,
  Flag_MD,
  Flag_ME,
  Flag_MF,
  Flag_MG,
  Flag_MH,
  Flag_MK,
  Flag_ML,
  Flag_MM,
  Flag_MN,
  Flag_MO,
  Flag_MP,
  Flag_MQ,
  Flag_MR,
  Flag_MS,
  Flag_MT,
  Flag_MU,
  Flag_MV,
  Flag_MW,
  Flag_MX,
  Flag_MY,
  Flag_MZ,
  Flag_NA,
  Flag_NC,
  Flag_NE,
  Flag_NF,
  Flag_NG,
  Flag_NI,
  Flag_NL,
  Flag_NO,
  Flag_NP,
  Flag_NR,
  Flag_NU,
  Flag_NZ,
  Flag_OM,
  Flag_PA,
  Flag_PE,
  Flag_PF,
  Flag_PG,
  Flag_PH,
  Flag_PK,
  Flag_PL,
  Flag_PN,
  Flag_PR,
  Flag_PS,
  Flag_PT,
  Flag_PW,
  Flag_PY,
  Flag_QA,
  Flag_RO,
  Flag_RS,
  Flag_RU,
  Flag_RW,
  Flag_SA,
  Flag_SB,
  Flag_SC,
  Flag_SD,
  Flag_SE,
  Flag_SG,
  Flag_SH,
  Flag_SI,
  Flag_SK,
  Flag_SL,
  Flag_SM,
  Flag_SN,
  Flag_SO,
  Flag_SR,
  Flag_SS,
  Flag_ST,
  Flag_SV,
  Flag_SY,
  Flag_SZ,
  Flag_TC,
  Flag_TD,
  Flag_TF,
  Flag_TG,
  Flag_TH,
  Flag_TJ,
  Flag_TK,
  Flag_TL,
  Flag_TM,
  Flag_TN,
  Flag_TO,
  Flag_TR,
  Flag_TT,
  Flag_TV,
  Flag_TW,
  Flag_TZ,
  Flag_UA,
  Flag_UG,
  Flag_US,
  Flag_UY,
  Flag_UZ,
  Flag_VA,
  Flag_VC,
  Flag_VE,
  Flag_VG,
  Flag_VI,
  Flag_VN,
  Flag_VU,
  Flag_WF,
  Flag_WS,
  Flag_YE,
  Flag_YT,
  Flag_ZA,
  Flag_ZM,
  Flag_ZW,
  Flag_abkhazia,
  Flag_basque_country,
  Flag_british_antarctic_territory,
  Flag_commonwealth,
  Flag_england,
  Flag_gosquared,
  Flag_kosovo,
  Flag_mars,
  Flag_nagorno_karabakh,
  Flag_nato,
  Flag_northern_cyprus,
  Flag_olympics,
  Flag_red_cross,
  Flag_scotland,
  Flag_somaliland,
  Flag_south_ossetia,
  Flag_united_nations,
  Flag_wales,

  UI_RateGameIcon,

  // NoLevelsDialog
  UI_NoLevelsTiger,
  UI_NoLevelsRibbon,
  UI_NoLevelsTape,
  UI_NoLevelsGradient,

  // Append new IDs here so existing numeric image keys stay stable.
  UI_ShopInfiniteHeart,

  // Passive boosters (PlayDialog)
  UI_PassiveBoosterDisabled,
  UI_PassiveBoosterEnabled,
  UI_PassiveBoosterSelectedBadge,
  UI_PassiveBoosterCountBadge,
  UI_PassiveBoosterPlusBadge,
  UI_PassiveBoosterMine,

  // MenuScreen widgets
  UI_MenuWidgetBgBlue,
  UI_MenuWidgetBgPurple,
  UI_MenuWidgetBlueBtn,
  UI_MenuWidgetGreenBtn,

  // DailyCardRewardOverlay
  UI_DailyCardRewardCardBack,
  UI_DailyCardRewardCardFront,
  UI_DailyCardRewardWidget,
  UI_DailyCardInfoImg,

  // Green box
  UI_GreenBox,
  UI_GreenBoxOpen,
  UI_PinkBox,
  UI_PinkBoxOpen,

  // WheelOfFortuneOverlay
  UI_WheelOfFortuneWidget,
  UI_WheelOfFortuneBg,
  UI_WheelOfFortuneButtonActive,
  UI_WheelOfFortuneButtonUnactive,
  UI_WheelOfFortuneCenter,
  UI_WheelOfFortunePointer,
  UI_WheelOfFortuneShinePurple,
  UI_WheelOfFortuneShineWhite,
  UI_WheelOfFortuneTitle,
  UI_WheelOfFortuneCape,
  UI_WheelOfFortuneContent,

  // FriendsScreen
  UI_FriendsCardBg,
  UI_FriendsHeaderBg,
  UI_FriendsTab,
  UI_FriendsTabActive,

  // FriendsInfoOverlay
  UI_FriendsInfoTop,
  UI_FriendsInfoCenter,
  UI_FriendsInfoBottom,

  // VFX ================================================================================================================
  
  CoinAtlas,
  ConfettiAtlas,
    
  // Glows
  CircleGlow1,
  CircleGlow2,
  CircleGlow3,
  CircleGlow4,
  CircleGlow5,
  SparkGlow2,
  SparkGlow3,
  RaysGlow1,
  LineGlow1,

  // ShopOverlay
  UI_ShopOverlayTop,
  UI_ShopOverlayBottom,
  UI_ShopOverlayItemHeader,
  UI_ShopOverlayStarsBg,
  UI_ShopOverlayTonBg,
  UI_ShopOverlayFriends,
  UI_ShopOverlayStarsIcon,
  UI_ShopOverlayWallet,
  UI_ShopOverlayWalletConnected,
  UI_ShopOverlayWalletDisconnected,
}
